import React from 'react';
import WhatsAppIcon from './icons/WhatsAppIcon';

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/77717004430"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 z-40 w-12 h-12 md:w-14 md:h-14 md:bottom-6 md:right-6 bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-full shadow-lg hover:shadow-xl transition-all flex items-center justify-center group"
      aria-label="Contact via WhatsApp"
      data-testid="whatsapp-floating-btn"
    >
      <WhatsAppIcon className="w-7 h-7 group-hover:scale-110 transition-transform" />
      
      {/* Tooltip */}
      <span className="absolute right-full mr-3 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
        WhatsApp
      </span>
      
      {/* Static ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-20"></span>
    </a>
  );
};

export default WhatsAppButton;
